export default "__VITE_ASSET__DJ8awKX0__"